import _jsx from '@babel/runtime/helpers/esm/jsx';
import { memo } from 'react';
import { Field } from 'redux-form/immutable';

const FieldComponentProp=()=>null,HiddenFieldWithValueInInitialValues=/*#__PURE__*/memo(a=>{let{name:b,validate:c}=a;return/*#__PURE__*/_jsx(Field,{name:b,validate:c,component:FieldComponentProp})});// This is an helper to define an "hidden" field with a value
// that doesn’t change in a `redux-form`.
// Remember to assign a value to this field in the initialValues object
// that you pass to `redux-form`.
HiddenFieldWithValueInInitialValues.displayName="HiddenFieldWithValueInInitialValues";

export { HiddenFieldWithValueInInitialValues as default };
